import { createFileRoute, useParams } from "@tanstack/react-router";
import { createJobNotesListQueryOptions } from "@/features/notes/adapters/job-notes-adapter";
import { JobNotesWorkspace } from "@/features/notes/components/job-notes-workspace";
import { NOTES_PAGE_SIZE } from "@/features/notes/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/notes",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createJobNotesListQueryOptions({
				jobId: params.jobId,
				organizationId: params.orgId,
				start: 1,
				count: NOTES_PAGE_SIZE,
			}),
		),
	component: JobWorkspaceNotesTab,
});

/**
 * Job workspace Notes tab — thin route adapter.
 */
function JobWorkspaceNotesTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/notes",
	});

	return <JobNotesWorkspace orgId={params.orgId} jobId={params.jobId} />;
}
